import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContractsRoutingModule } from './contracts-routing.module';
import { ContractListComponent } from './contract-list/contract-list.component';
import { ContractListViewComponent } from './contract-list/list-view/list-view.component';
import { ContractCardViewComponent } from './contract-list/card-view/card-view.component';
import { ContractDetailComponent } from './contract-detail/contract-detail.component';
import { ContractDetailAssetsComponent } from './contract-detail/contract-detail-assets/contract-detail-assets.component';
import { ContractDetailPaymentScheduleComponent } from './contract-detail/contract-detail-payment-schedule/contract-detail-payment-schedule.component';
import { ContractDetailCollateralsComponent } from './contract-detail/contract-detail-collaterals/contract-detail-collaterals.component';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { ContractDetailInsurancesComponent } from './contract-detail/contract-detail-insurances/contract-detail-insurances.component';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { ContractListFilterComponent } from './contract-list/contract-list-filter/contract-list-filter.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

@NgModule({
  imports: [
    CommonModule,
    ContractsRoutingModule,
    InputsModule,
    DropDownsModule,
    FormsModule,
    NgbModule,
    TranslateModule.forChild(),
    ComponentsModule,
    PipeModule,
    DateInputsModule,
  ],
  declarations: [
    ContractListComponent,
    ContractListViewComponent,
    ContractCardViewComponent,
    ContractDetailComponent,
    ContractDetailAssetsComponent,
    ContractDetailPaymentScheduleComponent,
    ContractDetailCollateralsComponent,
    ContractDetailInsurancesComponent,
    ContractListFilterComponent,
  ],
  exports: [ContractListViewComponent, ContractCardViewComponent],
})
export class ContractsModule {}
